import { render, staticRenderFns } from "./WeekdayQuiz.vue?vue&type=template&id=653306cb&scoped=true&lang=pug&"
import script from "./WeekdayQuiz.vue?vue&type=script&lang=js&"
export * from "./WeekdayQuiz.vue?vue&type=script&lang=js&"
import style0 from "./WeekdayQuiz.vue?vue&type=style&index=0&id=653306cb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653306cb",
  null
  
)

component.options.__file = "WeekdayQuiz.vue"
export default component.exports